import { ChangeDetectorRef, Directive, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { AuthService } from 'src/app/core/auth/service/auth.service';
import { BaseFormComponent } from 'src/app/shared/crud/base-form.component';

import { LayoutUtilsService } from './../../core/_base/crud/utils/layout-utils.service';

@Directive()
export abstract class BaseForgotPasswordComponent
  extends BaseFormComponent
  implements OnInit, OnDestroy
{
  requestSuccess = false;

  constructor(
    protected authService: AuthService | null = null,
    protected fb: FormBuilder | null = null,
    protected cdr: ChangeDetectorRef | null = null,
    protected layoutUtilsService: LayoutUtilsService | null = null
  ) {
    super();
  }

  ngOnInit(): void {
    super.initForm();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  createForm() {
    this.form = this.fb?.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  submit() {
    if (!this.validateForm()) {
      this.cdr?.detectChanges();
      return;
    }

    this.loadingSubject.next(true);
    const reset = this.form.getRawValue();

    this.authService
      ?.forgotPassword(reset)
      .pipe(
        finalize(() => {
          this.loadingSubject.next(false);
          this.cdr?.detectChanges();
        })
      )
      .subscribe(
        () => {
          this.layoutUtilsService?.showActionNotification({
            title: 'Solicitação Enviada!',
            html: `Te enviamos um email de confirmação para gerar sua nova senha
            <br><br>
            <small class="fs-8">* Lembre-se de verificar a caixa de spam caso não encontre o email na caixa de entrada.</small>`,
            icon: 'success',
          });

          this.router?.navigate(['/auth/login']);
        },
        (err) => {
          this.form.reset();
          let message = 'Ops! Não foi possível prosseguir com essa ação';
          if (err.error?.violations?.length > 0) {
            message = err.error.violations[0].message;
          } else if (err.error?.['hydra:description']) {
            message = err.error['hydra:description'];
          } else if (err.error?.message) {
            message = err.error.message;
          }
          this.layoutUtilsService?.showToastNotification({
            title: message,
            icon: 'error',
          });
        }
      );
  }
}
